/* eslint-disable react/jsx-no-useless-fragment */
/* eslint-disable no-console */
/* eslint-disable react/no-array-index-key */
import React, { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import ChevronIcon from "../../../Common/Svgs/ChevronIcon";
import WeightCollectedIcon from "../../../Common/Svgs/WeightCollectedIcon";
import WeightDeliveredIcon from "../../../Common/Svgs/WeightDeliveredIcon";
import SpoiltMilkIcon from "../../../Common/Svgs/SpoiltMilkIcon";
import { updateTrips } from "../../../Redux/Slices/trips.slice";
import FarmerBadge from "./FarmerBadge";
import ArrowIcon from "../../../Common/Svgs/ArrowIcon";
import ViewReceiptModal from "./ViewReceiptModal";
import ToastMessageModal from "../ToastMessageModal";
import EditIcon from "../../../Common/Svgs/EditIcon";
import { getStopSummary } from "../../../Redux/APIs/tripsAPI";

const Listings = ({ icon, title, value, unit = "per kg" }) => {
  const localUnit = unit?.split(" ")?.[1] || "kg";

  return (
    <div className="flex items-center justify-between my-2">
      <div className="flex items-center gap-x-2">
        {icon}
        <p className="font-aileron text-sm font-normal text-grey-200">
          {title}
        </p>
      </div>
      <p className="font-aileron text-sm font-semibold">
        {value} <span className="capitalize">{localUnit}</span>
      </p>
    </div>
  );
};

const FarmerCard = ({
  index,
  isOrigin = 1,
  isDestination = 1,
  farmerId,
  farmerName,
  farmerStop = 0,
  isNewFarmer = 0,
  farmerStopName,
  activities,
}) => {
  const { id, stopId } = useParams();
  const stopMetaDataFromOverallSummary = activities[0]?.metaData;

  const showReceiptData =
    activities[0]?.type === 2 &&
    stopMetaDataFromOverallSummary &&
    Object.keys(stopMetaDataFromOverallSummary).length > 0;

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const receiptStatus = activities[0]?.metaData?.receiptStatus;

  const getBadge = () => {
    if (isNewFarmer) {
      return (
        <div className="mt-4">
          <FarmerBadge type={1} text="New Entry" />
        </div>
      );
    }
    if (!isNewFarmer && farmerStop) {
      return (
        <div className="mt-4">
          <FarmerBadge
            type={2}
            text={`Farmer originally from stop ${farmerStopName}`}
          />
        </div>
      );
    }
    return <></>;
  };

  const onEditClick = (e, item) => {
    e.stopPropagation();

    dispatch(
      updateTrips({
        key: "editProduceModal",
        value: {
          visible: true,
          data: {
            produceId: item?.produceId || 0,
            produceName: item?.produce || "",
            farmerId: farmerId || 0,
          },
        },
      })
    );
  };

  return (
    <div
      className="p-4 rounded-2xl border border-light-grey"
      style={{ width: "49.3%" }}
      role={!isOrigin && !isDestination && "button"}
      onClick={() => {
        if (!isOrigin && !isDestination) {
          dispatch(
            updateTrips({
              key: "currentFarmer",
              value: {
                id: farmerId,
                name: farmerName,
                index,
                farmerStop,
                farmerStopName,
                isNewFarmer,
              },
            })
          );

          navigate(`/trips/${id}/${stopId}/${farmerId}`);
        }
      }}
    >
      <div className="pb-4 border-b border-[#E7E7E7]">
        {!isOrigin && !isDestination && (
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-x-2">
              <div className="w-6 h-6 bg-[#E7E7E7] rounded-full flex items-center justify-center">
                <p className="font-poppins text-xs font-semibold">
                  {index + 1}
                </p>
              </div>

              <p className="font-poppins text-base font-medium capitalize">
                {farmerName}
              </p>
            </div>

            <ChevronIcon className="w-5 h-5 stroke-grey-200" />
          </div>
        )}

        <div className="flex items-center gap-2 mt-2">
          {!isOrigin && !isDestination && getBadge()}
          {showReceiptData && (
            <div
              className={`py-0.5 px-2 mt-4 rounded max-w-max ${
                receiptStatus === 0 ? "bg-alert-red" : "bg-green"
              }`}
            >
              <p className="font-poppins text-xs font-normal text-background-white">
                {receiptStatus === 0
                  ? "Verification Pending"
                  : "Receipt Verified"}
              </p>
            </div>
          )}
        </div>
      </div>

      {activities.map((item, mapIndex) => (
        <div
          key={item.activityId}
          className={`mt-4 ${
            mapIndex !== 0 && "pt-4 border-t border-[#E7E7E7]"
          }`}
        >
          <div
            role="button"
            className="flex items-center gap-x-2"
            onClick={(e) => onEditClick(e, item)}
          >
            <div>
              <EditIcon />
            </div>

            <p className="font-poppins text-sm font-medium capitalize">
              {item.produce}
            </p>
          </div>
          {item.weightCollected && !item.isDestination ? (
            <Listings
              icon={<WeightCollectedIcon />}
              title="Total collected"
              value={item.weightCollected}
              unit={item?.unit}
            />
          ) : null}
          {item.weightDelivered && !item.isOrigin ? (
            <>
              <Listings
                icon={<WeightDeliveredIcon />}
                title="Total delivered"
                value={item.weightDelivered}
                unit={item?.unit}
              />
              {showReceiptData && (
                <button
                  className="w-full flex bg-primary-10 rounded-md p-4 justify-between border-primary border-[1px]"
                  type="button"
                  onClick={(e) => {
                    e.stopPropagation();

                    dispatch(
                      updateTrips({
                        key: "receiptModal",
                        value: {
                          visible: true,
                          data: activities[0],
                        },
                      })
                    );
                  }}
                >
                  <div className="flex">
                    <img
                      src={stopMetaDataFromOverallSummary?.receiptUrl}
                      className="h-[50px] w-[50px] rounded-4 mr-[14.5px]"
                      alt="receipt preview"
                    />
                    {stopMetaDataFromOverallSummary?.receiptStatus ? (
                      <div className="flex flex-col items-start">
                        <p className="font-poppins font-medium text-sm text-black">
                          Receipt Verified
                        </p>
                        <p className="font-aileron font-normal text-xs">
                          {stopMetaDataFromOverallSummary?.receiptId}
                        </p>
                      </div>
                    ) : (
                      <p className="flex items-center font-poppins font-medium text-sm">
                        View Receipt
                      </p>
                    )}
                  </div>
                  <div className="rotate-90 pt-4">
                    <ArrowIcon />
                  </div>
                </button>
              )}
            </>
          ) : null}
          {item.spoiltMilk ? (
            <Listings
              icon={<SpoiltMilkIcon />}
              title="Spoilt milk"
              value={item.spoiltMilk}
              unit="per litre"
            />
          ) : null}
        </div>
      ))}
    </div>
  );
};

const StopSummary = () => {
  const dispatch = useDispatch();
  const { currentStop, toastMessage, stopSummary, receiptModal } = useSelector(
    (state) => state.trips
  );

  // const [stopSummary, setStopSummary] = useState([]);

  // const getStopSummary = useCallback(async () => {
  //   try {
  //     dispatch(
  //       updateTrips({
  //         key: "loading",
  //         value: true,
  //       }),
  //     );

  //     const response = await client.get(
  //       `${process.env.REACT_APP_API_URL}/trip/get-farmer-activity`,
  //       {
  //         params: {
  //           stopId: currentStop.stopId,
  //           tripId: currentStop.tripId,
  //         },
  //       },
  //     );

  //     setStopSummary([...response.data.farmerActivity]);
  //   } catch (error) {
  //     console.log(error);
  //   } finally {
  //     dispatch(
  //       updateTrips({
  //         key: "loading",
  //         value: false,
  //       }),
  //     );
  //   }
  // }, [dispatch, currentStop]);

  const getFilteredActivities = (activities) => {
    if (currentStop.isOrigin) {
      return activities.filter((item) => item.isOrigin);
    }

    if (currentStop.isDestination) {
      return activities.filter((item) => item.isDestination);
    }

    return activities;
  };

  useEffect(() => {
    dispatch(
      getStopSummary({
        stopId: currentStop.stopId,
        tripId: currentStop.tripId,
      })
    );
  }, [dispatch, currentStop]);

  useEffect(() => {
    const tripTimer = setTimeout(() => {
      dispatch(
        updateTrips({
          key: "toastMessage",
          value: { ...toastMessage, visible: false },
        })
      );
    }, 5000);

    return () => clearTimeout(tripTimer);
  }, [dispatch, toastMessage]);

  return (
    <div className="p-6 bg-background-white h-[calc(100vh-128px)] overflow-y-scroll">
      {stopSummary?.length ? (
        !stopSummary[0].isOrigin &&
        !stopSummary[0].isDestination && (
          <p className="font-poppins text-xs font-medium mb-4">
            {stopSummary.length === 1
              ? "1 Farmer"
              : `${stopSummary.length} Farmers`}
          </p>
        )
      ) : (
        <p className="font-poppins text-xs font-medium mb-4">
          No activity exists for this stop
        </p>
      )}
      <div className="flex flex-wrap gap-4 w-full">
        {stopSummary?.map((item, index) => (
          <FarmerCard
            key={index}
            index={index}
            isOrigin={item.isOrigin}
            isDestination={item.isDestination}
            farmerId={item.farmerId}
            farmerName={item.farmerName}
            farmerStop={item.farmerStop}
            farmerStopName={item.farmerStopName}
            isNewFarmer={item.isNewFarmer}
            activities={getFilteredActivities(item.activities)}
          />
        ))}
      </div>

      <ViewReceiptModal
        visible={receiptModal?.visible}
        onCancel={() => {
          dispatch(
            updateTrips({
              key: "receiptModal",
              value: {
                visible: false,
                data: {},
              },
            })
          );
        }}
      />

      <div className="fixed z-[2000]">
        <ToastMessageModal
          visible={toastMessage.visible}
          onCancel={() =>
            dispatch(
              updateTrips({
                key: "toastMessage",
                value: { ...toastMessage, visible: false },
              })
            )
          }
        />
      </div>
    </div>
  );
};

export default StopSummary;
